import gsap, { Linear } from 'gsap';
import Environment from '../environment';

const duration = Environment.isVerizon1100() ? 0 : 0.5;

export const EFFECTS = Object.freeze({
	fadeIn: 'fadeIn',
	fadeOut: 'fadeOut',
});

gsap.registerEffect({
	name: EFFECTS.fadeIn,
	effect: (targets, config) => gsap.to(targets, config),
	defaults: {
		duration,
		autoAlpha: 1,
		ease: Linear.easeNone,
	},
	extendTimeline: true,
});

gsap.registerEffect({
	name: EFFECTS.fadeOut,
	effect: (targets, config) => gsap.to(targets, config),
	defaults: {
		duration,
		autoAlpha: 0,
		ease: Linear.easeNone,
	},
	extendTimeline: true,
});

export default gsap;
